import {
  SET_TIME_BEING_SELECTED,
  SET_CURRENT_SELECTED_IMAGE,
  CLEAR_CURRENT_SELECTED_IMAGE,
  CLEAR_CURRENT_IMAGE_PAIR
} from '../../constants/appTypes';

import { ITimelineImageObject } from '../../types/timeline';

const initialState: {
  isBefore: boolean;
  before: ITimelineImageObject | undefined;
  after: ITimelineImageObject  | undefined;
} = {
  isBefore: false,
  before: undefined,
  after: undefined
};
interface currentImagePairAction {
  isBefore?: boolean;
  image?: ITimelineImageObject;
  type: string;
}

export function currentImagePair(state = initialState, action: currentImagePairAction) {
  const { isBefore, image, type } = action;
  let updatedState;
  switch (type) {
    case SET_TIME_BEING_SELECTED:
      return { ...state, isBefore: isBefore || false };
    case SET_CURRENT_SELECTED_IMAGE:
      updatedState = { ...state };
      if (isBefore) {
        updatedState.before = image;
      } else {
        updatedState.after = image;
      }
      return updatedState;
    case CLEAR_CURRENT_SELECTED_IMAGE:
      updatedState = { ...state };
      if (isBefore) {
        updatedState.before = undefined;
      } else {
        updatedState.after = undefined;
      }
      return updatedState;
    case CLEAR_CURRENT_IMAGE_PAIR:
      return initialState;
    default:
      return state;
  }
}

export default currentImagePair;
